module.exports = __webpack_public_path__ + "static/other/gameLandscape.0e4f34e5.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameLandscape.json
// module id = 862
// module chunks = 0